import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const get = gql`
  query GetBillingQuery {
    billing: getBilling {
      customer {
        subscriptions {
          status
          isPaidPlan
          trialEnd
          limits {
            type
            unit
            value
          }
        }
      }
    }
  }
`;

export const getUserCount = gql`
  query GetUserCountQuery($businessId: Int!) {
    me {
      business(businessId: $businessId) {
        userCount
      }
    }
  }
`;

export const usageMetrics = gql`
  query ListUsageMetricsQuery {
    metrics: summarizeUsageMetrics {
      type
      value
    }
  }
`;

export const listSubscriptionPlans = gql`
  query ListSubscriptionPlans {
    subscriptionPlans: listSubscriptionPlans {
      ...SubscriptionPlan
    }
  }

  ${Fragments.billing.subscriptionPlan}
`;
